/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import { connect } from 'react-redux';
import Content from './content.component';
import { withRouter } from 'react-router-dom';
import {
  hideMigrationModal,
  hideMigrationSuccessModal,
  hideMigrationErrorModal,
  openSponsorModal,
  selectTenantAndSetCookie,
  showMigrationModal,
  showMigrationSuccessModal,
  showMigrationErrorModal,
  updateIdPortalMigrationStatus,
  logOutAndCleanSession
} from '../../../actions/actions';
import { MODAL_TYPE_SPONSORS } from '../../../constants/modalTypes';
import { SELECT_SPONSOR_MODAL_TITLE } from '../../../const';
import { fetchLoggedUserDetails } from '../../../actions/rolemanagement.actions';
import { path } from 'ramda';

export const mapStateToProps = (state) => {
  return {
    user: state.login.user,
    error: state.login.error || state.roles.error,
    selectedSponsor: state.sponsor.selectedSponsor,
    selectSponsorError: state.sponsor.selectSponsorError,
    productionTenantForUAT: state.subject.productionTenantForUAT,
    fetchingUserDetails: state.sponsor.fetchingUserDetails,
    isFetching: state.sponsor.isFetching,
    userAssignment: path(['rolemanagement', 'loggedUser'], state),
    idPortalMigration: state.idPortalMigration.idPortalStatus,
    isMigrationModalOpen: state.modal.isMigrationModalOpen,
    isMigrationModalSuccessOpen: state.modal.isMigrationModalSuccessOpen,
    isMigrationModalErrorOpen: state.modal.isMigrationModalErrorOpen,
    logoutUrl: state.login.clientConfiguration.SSOLogoutUrl
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  const { history } = ownProps;
  return {
    selectTenantAndSetCookie: (sponsor) => {
      dispatch(selectTenantAndSetCookie(sponsor, history));
    },
    dispatchSelectSponsorModal() {
      dispatch(
        openSponsorModal(MODAL_TYPE_SPONSORS, {
          title: SELECT_SPONSOR_MODAL_TITLE,
          shouldCloseOnOverlayClick: false
        })
      );
    },
    fetchAssignments(userId, sponsor) {
      dispatch(fetchLoggedUserDetails(userId, sponsor));
    },
    showMigrationModal() {
      dispatch(showMigrationModal());
    },
    hideMigrationModal() {
      dispatch(hideMigrationModal());
    },
    showMigrationSuccessModal() {
      dispatch(showMigrationSuccessModal());
    },
    hideMigrationSuccessModal() {
      dispatch(hideMigrationSuccessModal());
    },
    showMigrationErrorModal() {
      dispatch(showMigrationErrorModal());
    },
    hideMigrationErrorModal() {
      dispatch(hideMigrationErrorModal());
    },
    updateIdPortalMigrationStatus(idPortalMigration) {
      dispatch(updateIdPortalMigrationStatus(idPortalMigration));
    },
    signOut: (SSOLogoutUrl) => {
      dispatch(logOutAndCleanSession(SSOLogoutUrl));
    }
  };
};

const CContent = withRouter(connect(mapStateToProps, mapDispatchToProps)(Content));

export default CContent;
export { Content as PureContent };
